export const NAMESPACE = 'customer';
